// extracted by mini-css-extract-plugin
export default {"ProtectedRoute":"ProtectedRoute_ProtectedRoute__fk5BO"};